module.exports = __webpack_public_path__ + "img/50effective.fb64713f.png";